import React, { Component } from 'react';
import {
  Button, TextArea, Tooltip, Modal, TextInput
} from 'carbon-components-react';
import _ from 'lodash';
import MessagesModels from './MessagesModels';
import { StepCard } from '..';
import CancelModal from '../Modal/CancelModal';
import { parseModelMessage } from '../../utils';

class Message extends Component {
  constructor(props) {
    super(props);

    // Inicializa o estado com valores padrão
    this.state = {
      modelsModal: false,
      selectedMessageModel: props.selectedValue || '',
      nextMessageModel: '',
      cancelModal: false,
      charactersModal: false,
      isEdited: false,
      countCaracters: 0,
      messageType: 'sms', // Valor padrão, será atualizado no componentDidMount
      pushTitle: '',
      pushBody: '',
      errors: {
        sms: '',
        pushTitle: '',
        pushBody: ''
      }
    };

    // Log para debug
    //   console.log('Message constructor - props:', props);
  }

  componentDidMount() {
    // Determina o tipo de mensagem com base nos dados do pedido
    this.updateMessageTypeFromProps();

    // Inicializa a contagem de caracteres
    this.countCaracteresMessage();

    // Verifica se já existe uma mensagem e tenta detectar o tipo
    this.detectMessageType();
  }

  componentDidUpdate(prevProps) {
    // Se os dados do pedido mudaram, atualiza o tipo de mensagem
    if (prevProps.data !== this.props.data) {
      this.updateMessageTypeFromProps();
    }
  }

  // Método para atualizar o tipo de mensagem com base nos dados do pedido
  updateMessageTypeFromProps = () => {
    const { data } = this.props;

    if (data) {
      //  console.log('Dados do pedido:', data);

      // Verifica se push está ativado (id = 1)
      if (data.push && data.push.id === 1) {
        //  console.log('Tipo de mensagem definido como PUSH');
        this.setState({ messageType: 'push' });
        return;
      }

      // Verifica se sms está ativado (id = 1)
      if (data.sms && data.sms.id === 1) {
        //  console.log('Tipo de mensagem definido como SMS');
        this.setState({ messageType: 'sms' });
        return;
      }
    }
  }

  detectMessageType = () => {
    const { selectedMessageModel } = this.state;

    // Verifica se a mensagem já existente parece ser um push (contém o formato específico)
    if (selectedMessageModel && selectedMessageModel.includes('titulo:') && selectedMessageModel.includes('--- corpo:')) {
      try {
        // Extrai o título e o corpo da mensagem existente
        const titleMatch = selectedMessageModel.match(/titulo:(.*?)---/);
        const bodyMatch = selectedMessageModel.match(/--- corpo:(.*)/);

        if (titleMatch && titleMatch[1] && bodyMatch && bodyMatch[1]) {
          this.setState({
            pushTitle: titleMatch[1].trim(),
            pushBody: bodyMatch[1].trim(),
          });
        }
      } catch (error) {
        console.error('Erro ao analisar mensagem push:', error);
      }
    }
  }

  toggleModelsModal = () => {
    this.setState(prevState => ({ modelsModal: !prevState.modelsModal }));
  };

  toggleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  toggleModalCharacters = () => {
    this.setState(prevState => ({ charactersModal: !prevState.charactersModal }));
  };

  countCaracteresMessage = () => {
    const { selectedMessageModel, messageType, pushTitle, pushBody } = this.state;

    // Lógica para contar caracteres com base no tipo de mensagem
    if (messageType === 'push') {
      // Para push, contamos separadamente o título e corpo
      const titleLength = pushTitle.length;
      const bodyLength = pushBody.length;

      // Verificamos as tags especiais no título e corpo
      const foundTagOnTitle = pushTitle.indexOf('<NOME_CRM>') > -1;
      const foundTagTwoTitle = pushTitle.indexOf('<NOME_CLIENTE>') > -1;
      const foundTagOnBody = pushBody.indexOf('<NOME_CRM>') > -1;
      const foundTagTwoBody = pushBody.indexOf('<NOME_CLIENTE>') > -1;

      let plusTitle = 0;
      let plusBody = 0;

      if (foundTagOnTitle) plusTitle += 10;
      if (foundTagTwoTitle) plusTitle += 1;
      if (foundTagOnBody) plusBody += 10;
      if (foundTagTwoBody) plusBody += 1;

      this.setState({
        countCaracters: bodyLength + plusBody,
        errors: {
          ...this.state.errors,
          pushTitle: titleLength > 50 ? 'O título deve ter no máximo 50 caracteres' : '',
          pushBody: bodyLength > 120 ? 'O corpo deve ter no máximo 120 caracteres' :
            (bodyLength < 100 && bodyLength > 0) ? 'O corpo deve ter no mínimo 100 caracteres' : ''
        }
      });
    } else {
      // Para SMS, contamos o total de caracteres
      const foundTagOn = selectedMessageModel.indexOf('<NOME_CRM>') > -1;
      const foundTagTwo = selectedMessageModel.indexOf('<NOME_CLIENTE>') > -1;
      let nrCaracters = selectedMessageModel.length;

      let plus = 0;
      if (foundTagOn) plus += 10;
      if (foundTagTwo) plus += 1;

      nrCaracters += plus;

      // Verificar se há emojis ou caracteres especiais
      const hasSpecialChars = /[^\x00-\x7F]/.test(selectedMessageModel);

      this.setState({
        countCaracters: nrCaracters,
        errors: {
          ...this.state.errors,
          sms: hasSpecialChars
            ? 'SMS não deve conter emojis ou caracteres especiais'
            : (nrCaracters > 160 ? 'O SMS deve ter no máximo 160 caracteres' : '')
        }
      });
    }
  };

  onChangeMessage = (event) => {
    this.setState(
      {
        selectedMessageModel: event.target.value,
        isEdited: true
      }, () => {
        this.countCaracteresMessage();
      });
  };

  onChangePushTitle = (event) => {
    this.setState(
      {
        pushTitle: event.target.value,
        isEdited: true
      },
      () => {
        // Atualiza o campo combinado para o backend
        this.updateCombinedMessage();
        this.countCaracteresMessage();
      }
    );
  };

  onChangePushBody = (event) => {
    this.setState(
      {
        pushBody: event.target.value,
        isEdited: true
      },
      () => {
        // Atualiza o campo combinado para o backend
        this.updateCombinedMessage();
        this.countCaracteresMessage();
      }
    );
  };

  updateCombinedMessage = () => {
    const { pushTitle, pushBody } = this.state;
    // Combina os campos de push no formato especificado para o backend
    // Formato: "titulo: [texto do título] --- corpo: [texto do corpo]"
    const combinedMessage = `titulo: ${pushTitle} --- corpo: ${pushBody}`;
    this.setState({ selectedMessageModel: combinedMessage });
  };

  onChangeModel = (message) => {
    this.setState({ nextMessageModel: message });
  };

  onSelectModel = () => {
    const { nextMessageModel, messageType } = this.state;

    if (messageType === 'push') {
      // Estamos no modo PUSH
      if (nextMessageModel.includes('titulo:') && nextMessageModel.includes('--- corpo:')) {
        // O modelo já está no formato PUSH
        try {
          const titleMatch = nextMessageModel.match(/titulo:(.*?)---/);
          const bodyMatch = nextMessageModel.match(/--- corpo:(.*)/);

          if (titleMatch && titleMatch[1] && bodyMatch && bodyMatch[1]) {
            this.setState({
              selectedMessageModel: nextMessageModel,
              pushTitle: titleMatch[1].trim(),
              pushBody: bodyMatch[1].trim(),
              isEdited: true,
            });
          } else {
            // Se não conseguir extrair, coloca todo o conteúdo no corpo
            this.setState({
              pushTitle: '',
              pushBody: nextMessageModel,
              isEdited: true,
            }, () => {
              this.updateCombinedMessage();
            });
          }
        } catch (error) {
          console.error('Erro ao analisar modelo push:', error);
          this.setState({
            pushTitle: '',
            pushBody: nextMessageModel,
            isEdited: true,
          }, () => {
            this.updateCombinedMessage();
          });
        }
      } else {
        // O modelo não está no formato PUSH, coloca todo o conteúdo no corpo
        this.setState({
          pushTitle: '',
          pushBody: nextMessageModel,
          isEdited: true,
        }, () => {
          this.updateCombinedMessage();
        });
      }
    } else {
      // Estamos no modo SMS
      this.setState({
        selectedMessageModel: nextMessageModel,
        isEdited: true,
      });
    }

    this.toggleModelsModal();
    this.countCaracteresMessage();
  };

  addTag = (tag) => {
    const { messageType } = this.state;

    if (messageType === 'push') {
      // Adiciona a tag ao campo que está em foco ou ao corpo por padrão
      const activeElement = document.activeElement;
      if (activeElement && activeElement.id === 'push-title') {
        this.setState(prevState => ({
          pushTitle: `${prevState.pushTitle}${tag}`,
          isEdited: true
        }), () => {
          this.updateCombinedMessage();
          this.countCaracteresMessage();
        });
      } else {
        // Adiciona ao corpo por padrão
        this.setState(prevState => ({
          pushBody: `${prevState.pushBody}${tag}`,
          isEdited: true
        }), () => {
          this.updateCombinedMessage();
          this.countCaracteresMessage();
        });
      }
    } else {
      // Adiciona a tag à mensagem SMS
      this.setState(prevState => ({
        selectedMessageModel: `${prevState.selectedMessageModel}${tag}`,
        isEdited: true
      }), () => {
        this.countCaracteresMessage();
      });
    }
  };

  hasErrors = () => {
    const { errors, messageType, pushBody } = this.state;

    if (messageType === 'push') {
      // Para push, verificamos apenas o limite máximo (não bloqueamos por limite mínimo)
      return errors.pushTitle || (errors.pushBody && pushBody.length > 120);
    } else {
      return errors.sms;
    }
  };

  save = async () => {
    const { selectedMessageModel } = this.state;
    const { step, saveStep } = this.props;

    // Preparar os dados para salvar
    const saveData = {
      mensagem: (step.form === 'mensagem' && selectedMessageModel) || null,
      informacoesSAC: (step.form === 'sac' && selectedMessageModel) || null,
      salvouMensagem: step.form === 'mensagem' || null,
      salvouInfoSAC: step.form === 'sac' || null,
    };

    await saveStep(
      _.omitBy(saveData, _.isNil),
    );

    this.setState({ charactersModal: false });
    this.stepCardRef.toggleContent();
  };

  requestCancel = () => {
    const { isEdited } = this.state;
    if (isEdited) {
      this.toggleCancelModal();
    } else {
      this.cancel();
    }
  };

  cancel = () => {
    const { selectedValue } = this.props;
    this.setState({
      selectedMessageModel: selectedValue,
      isEdited: false,
      cancelModal: false,
    });
    this.stepCardRef.toggleContent();
    // Detecta o tipo de mensagem novamente
    this.detectMessageType();
  };

  renderDescription = () => {
    const { step, selectedValue } = this.props;
    if (selectedValue) {
      // Para mensagens do tipo push, exibimos de forma mais amigável
      if (selectedValue.includes('titulo:') && selectedValue.includes('--- corpo:')) {
        try {
          // Extrai o título e o corpo da mensagem
          const titleMatch = selectedValue.match(/titulo:(.*?)---/);
          const bodyMatch = selectedValue.match(/--- corpo:(.*)/);
          if (titleMatch && titleMatch[1] && bodyMatch && bodyMatch[1]) {
            return (
              <div className="font-size-13" style={{ color: '#36474f' }}>
                <strong>
                  {step.form === 'mensagem' ? 'Mensagem PUSH' : 'Instrução'}:
                </strong>
                <br />
                <div>
                  <strong>Título:</strong> {titleMatch[1].trim()}
                  <br />
                  <strong>Corpo:</strong> {bodyMatch[1].trim()}
                </div>
              </div>
            );
          }
        } catch (error) {
          console.error('Erro ao renderizar descrição push:', error);
        }
      }
      // Para SMS normal ou caso não consiga extrair título/corpo do push
      return (
        <div className="font-size-13" style={{ color: '#36474f' }}>
          <strong>
            {step.form === 'mensagem' ? 'Mensagem' : 'Instrução'}:
          </strong>
          <br />
          <div
            dangerouslySetInnerHTML={{
              __html: parseModelMessage(selectedValue),
            }}
          />
        </div>
      );
    }
    return step.description;
  };

  shouldShowCharactersWarning = () => {
    const { countCaracters, messageType, errors, pushBody } = this.state;
    if (messageType === 'sms') {
      return countCaracters > 160 || errors.sms;
    } else {
      // Para push, verificamos apenas o limite máximo (não alertamos por limite mínimo)
      return errors.pushTitle || (pushBody.length > 120);
    }
  };

  render() {
    const {
      modelsModal, selectedMessageModel, cancelModal, charactersModal,
      countCaracters, messageType, pushTitle, pushBody, errors
    } = this.state;

    const { step, selectedValue, disabled, showSave, data } = this.props;

    // Verifica diretamente os dados do pedido para determinar o tipo de mensagem
    let currentMessageType = messageType;

    if (data) {
      if (data.push && data.push.id === 1) {
        currentMessageType = 'push';
      } else if (data.sms && data.sms.id === 1) {
        currentMessageType = 'sms';
      }
    }

    // Exibe o tipo de mensagem atual e os dados para depuração
    // console.log('Message render - messageType:', messageType);
    //  console.log('Message render - currentMessageType:', currentMessageType);
    // console.log('Message render - data:', data);

    // Determina os limites com base no tipo de mensagem
    const characterLimit = currentMessageType === 'sms' ? 160 : 120;

    // Adiciona um indicador visual do tipo de mensagem
    const messageTypeIndicator = (
      <div className="message-type-indicator" style={{
        backgroundColor: '#f4f4f4',
        padding: '8px 16px',
        borderRadius: '4px',
        marginBottom: '16px'
      }}>
        <p style={{ margin: 0, fontWeight: 'bold' }}>
          Tipo de Mensagem: {currentMessageType === 'sms' ? 'SMS' : 'Push'}
        </p>
      </div>
    );

    return (
      <StepCard
        onRef={(ref) => {
          this.stepCardRef = ref;
        }}
        title={step.title}
        description={this.renderDescription()}
        isFinished={!!selectedValue}
        disabled={disabled}
      >
        <div className="bx--grid">
          <div className="bx--row">
            <div className="bx--col-xs-12">
              <label>O que você quer comunicar?</label>
              <Button
                kind="secondary"
                className="v-md-margin full-width"
                onClick={this.toggleModelsModal}
              >
                Selecionar um modelo
              </Button>
            </div>

            {/* Indicador do tipo de mensagem */}
            <div className="bx--col-xs-12">
              {messageTypeIndicator}
            </div>

            {/* Campos específicos para Push */}
            {currentMessageType === 'push' ? (
              <div className="bx--col-xs-12">
                <div className="bx--row">
                  <div className="bx--col-xs-12 v-md-margin">
                    <TextInput
                      id="push-title"
                      labelText="Título do Push (máx. 50 caracteres)"
                      value={pushTitle}
                      onChange={this.onChangePushTitle}
                      invalid={!!errors.pushTitle}
                      invalidText={errors.pushTitle}
                      placeholder="Digite o título"
                    />
                    <div className="bx--form-helper-text">
                      {`${pushTitle.length}/50 caracteres`}
                    </div>
                  </div>
                </div>
                <div className="bx--row">
                  <div className="bx--col-xs-12">
                    <TextArea
                      labelText="Corpo do Push (100-120 caracteres recomendados)"
                      value={pushBody}
                      onChange={this.onChangePushBody}
                      placeholder="Digite o corpo da mensagem"
                      invalid={!!errors.pushBody && pushBody.length > 120}
                      invalidText={errors.pushBody}
                    />
                    <div className="bx--form-helper-text"
                      style={{ color: pushBody.length > 120 ? 'red' : (pushBody.length < 100 && pushBody.length > 0) ? 'orange' : '' }}>
                      {`${pushBody.length}/120 caracteres`}
                      {pushBody.length < 100 && pushBody.length > 0 &&
                        " (recomendado: mínimo 100 caracteres)"}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              // Campo para SMS
              <div className="bx--col-xs-12">
                <TextArea
                  labelText={`Mensagem SMS (máx. ${characterLimit} caracteres)`}
                  value={selectedMessageModel}
                  onChange={this.onChangeMessage}
                  placeholder="Digite sua mensagem"
                  invalid={!!errors.sms}
                  invalidText={errors.sms}
                />
                <div className="bx--form-helper-text"
                  style={{ color: countCaracters > characterLimit ? 'red' : '' }}>
                  {`${countCaracters}/${characterLimit} caracteres`}
                </div>
                <div className="bx--form-helper-text">
                  Não são permitidos emojis ou caracteres especiais em mensagens SMS.
                </div>
              </div>
            )}

            {step.form === 'mensagem' && (
              <div className="bx--row flexible sm-margin">
                <div className="bx--col-xs-12 bx--col-sm-auto">
                  <Tooltip triggerText="Tags especiais" clickToOpen>
                    <p className="bx--tooltip__label">
                      Nome do cliente:
                      <br />
                      É preenchido automaticamente o nome do cliente que está recebendo a mensagem.
                      Exemplo: "João", "Maria"
                      <br />
                      Recomendação: Usar sempre no início de toda mensagem
                      <br />
                      <br />
                      Nome da Loja:
                      <br />
                      É preenchido automaticamente o nome da unidade que foi selecionada para receber essa mensagem.
                      <br />
                      Exemplo: "Supermercado bom"
                      <br />
                      Recomendação: Usar quando a mensagem for destinada para duas unidades diferentes, mas o restante do texto é igual.
                    </p>
                  </Tooltip>
                </div>
                <div className="tags bx--col-xs-12 bx--col-sm-auto">
                  <button
                    className="button button--clear"
                    onClick={() => this.addTag('<NOME_CRM>')}
                    type="submit"
                  >
                    <span className="bx--tag bx--tag--ibm">Nome da Loja</span>
                  </button>
                  <button
                    className="button button--clear"
                    onClick={() => this.addTag('<NOME_CLIENTE>')}
                    type="submit"
                  >
                    <span className="bx--tag bx--tag--ibm">Nome do Cliente</span>
                  </button>
                </div>
                <div className="bx--col-xs-6 bx--col-sm-auto">
                  <p
                    className="font-size-13"
                    style={{ color: this.shouldShowCharactersWarning() ? 'red' : '' }}
                  >
                    {countCaracters}
                    /{characterLimit}
                  </p>
                </div>
              </div>
            )}
          </div>
          {showSave && (
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-sm-6 v-md-margin">
                <Button
                  onClick={() => {
                    if (this.shouldShowCharactersWarning() && step.form === 'mensagem') {
                      this.toggleModalCharacters();
                    } else {
                      this.save();
                    }
                  }}
                  disabled={!selectedMessageModel || this.hasErrors()}
                >
                  Salvar
                </Button>
                <Button kind="ghost" className="h-sm-margin" onClick={this.requestCancel}>
                  Cancelar
                </Button>
              </div>
            </div>
          )}
          <Modal
            className="modelos-mensagens"
            modalHeading="Modelos de Mensagens"
            primaryButtonText="Selecionar"
            secondaryButtonText="Cancelar"
            onRequestSubmit={() => this.onSelectModel()}
            onRequestClose={() => this.toggleModelsModal()}
            open={modelsModal}
          >
            {modelsModal && (
              <MessagesModels
                type={step.form === 'mensagem' ? 1 : 2}
                onChangeModel={this.onChangeModel}
                messageType={currentMessageType} // Passa o tipo atual para filtrar modelos relevantes
              />
            )}
          </Modal>
          <Modal
            modalHeading={currentMessageType === 'sms' ? "Limite de caracteres excedido" : "Verificação de mensagem"}
            primaryButtonText="Continuar mesmo assim"
            secondaryButtonText="Cancelar"
            onRequestSubmit={() => this.save()}
            onRequestClose={() => this.toggleModalCharacters()}
            open={charactersModal}
          >
            {currentMessageType === 'sms' ? (
              <div>
                <h4>A sua mensagem ultrapassa os {characterLimit} caracteres, o que pode aumentar o custo de envio.</h4>
                <p>
                  Sugerimos que refaça sua mensagem ou utilize um de
                  {' '}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      this.toggleModelsModal();
                    }}
                  >
                    nossos modelos.
                  </a>
                </p>
              </div>
            ) : (
              <div>
                <h4>Verifique sua mensagem Push</h4>
                {errors.pushTitle && <p style={{ color: 'red' }}>{errors.pushTitle}</p>}
                {pushBody.length > 120 && (
                  <p style={{ color: 'red' }}>O corpo deve ter no máximo 120 caracteres</p>
                )}
                {pushBody.length < 100 && pushBody.length > 0 && (
                  <p style={{ color: 'orange' }}>Recomendamos que o corpo da mensagem tenha pelo menos 100 caracteres para melhor engajamento.</p>
                )}
              </div>
            )}
          </Modal>
          <CancelModal open={cancelModal} onOk={this.cancel} onCancel={this.toggleCancelModal} />
        </div>
      </StepCard>
    );
  }
}

export default Message;



// WEBPACK FOOTER //
// ./src/components/campaigns/Message.js